export enum AppLanguage {
  English = 'en',
  French = 'fr',
  Croatian = 'hr',
  Deutch = 'de'
}
